import { chowlyApi } from 'config'
import { generatePath } from 'react-router-dom'
import client from '../chowly'
import {
  TypeName,
  SyncLifecycleStatusAttributes,
  SyncLifecycleStatusResponse,
  PublishMenuStatusResource,
  PublishMenuStatusAttributes,
} from '../models'
import { ReportingOrdersPlatformName } from 'types'
import { calculateDurationInSeconds } from '../util'

export type SyncLifecycleStatusWithDurations = SyncLifecycleStatusAttributes & {
  initialImportDuration: number
  publishDuration: number
  toosProcessingDuration: number
  publishMenuStatuses: Record<ReportingOrdersPlatformName, PublishMenuStatusAttributes>  // map by platform name
}

// GET /api/v3/reporting/sync_lifecycles/:id?include=publish_menu_statuses
export const fetchSyncLifecycleStatus = async (
  id: string
): Promise<SyncLifecycleStatusWithDurations> => {
  const path = generatePath(chowlyApi.syncLifecycleStatus, { id })
  const url = `${path}?include=publish_menu_statuses`

  const response = await client.get<SyncLifecycleStatusResponse>(url)
   const attributes = response.data.data.attributes
  const included = response.data.included ?? []

  const initialImportDuration = calculateDurationInSeconds(
    attributes.import_started_at,
    attributes.import_completed_at
  ) ?? 0

  const publishDuration = calculateDurationInSeconds(
    attributes.publish_started_at,
    attributes.publish_completed_at
  ) ?? 0

  const toosProcessingDuration = calculateDurationInSeconds(
    attributes.publish_completed_at,
    attributes.external_processing_completed_at
  ) ?? 0

  const publishMenuStatusesArray = (included as PublishMenuStatusResource[])
    .filter(item => item.type === TypeName.PublishMenuStatus)
    .map(item => ({ ...item.attributes }))

  const publishMenuStatuses = publishMenuStatusesArray.reduce<Record<ReportingOrdersPlatformName, PublishMenuStatusAttributes>>(
    (acc, status) => {
      if (Object.values(ReportingOrdersPlatformName).includes(status.order_platform_name as ReportingOrdersPlatformName)) {
        acc[status.order_platform_name as ReportingOrdersPlatformName] = status
      }
      return acc
    },
    {} as Record<ReportingOrdersPlatformName, PublishMenuStatusAttributes>
  )

  return {
    ...attributes,
    initialImportDuration,
    publishDuration,
    toosProcessingDuration,
    publishMenuStatuses,
  }
}